/**
 * Responsible for all map functionality
 */

import createHTMLMapMarker from "./modules/maps/html-map-marker.js";
import { DefaultMapTheme } from "./modules/maps/default-map-theme";
import { DynamicMapTheme } from "./modules/maps/dynamic-map-theme";

(() => {
	class Maps {
		constructor(sector) {
			const rootEl = sector;
			if (rootEl instanceof window.HTMLElement) {
				let stylez;
				const map = rootEl.querySelector('.maps__map');
				
				const markersEl = rootEl.querySelectorAll('.maps__marker');

				// Set colour theme for map
				const theme = sector.dataset.theme;
				if(theme) {
					stylez = new DynamicMapTheme(theme)
				} else {
					stylez = new DefaultMapTheme()
				}
					

				// Create map
				// eslint-disable-next-line no-undef
				const generatedMap = new google.maps.Map(map, {
					zoom: Number(sector.dataset.zoom),
					// eslint-disable-next-line no-undef
					center: new google.maps.LatLng(0, 0),
					styles: stylez,
					scrollwheel: false,
					navigationControl: false,
					mapTypeControl: false,
					scaleControl: false,
					draggable: true,
				});

				// add a markers reference
				generatedMap.markers = [];

				// add each marker to the map
				markersEl.forEach((el) => {
					addMarker(el, generatedMap);
				});
				// // center map
				centerMap(generatedMap, Number(sector.dataset.zoom), markersEl);
				// return
				return generatedMap;

				function addMarker(markerIcon, map) {

					const lat = parseFloat(markerIcon.dataset.lat);
					const lng = parseFloat(markerIcon.dataset.long);
					const latLng = new google.maps.LatLng(lat, lng);
					const label = markerIcon.dataset.label;
					const icon = markerIcon.dataset.icon;
					const url = markerIcon.dataset.url;
					let marker;
					
					if(icon) {

						marker = createHTMLMapMarker({
							latlng: latLng,
							map: map,
							html: `<div class="custom-marker-container"><div class="custom-pin"><span></span></div><div class="custom-line"></div><div class="custom-marker"><img width="45" height="45" src="${icon}"><span>${label}</span></div></div>`
						});

					} else {

						marker = createHTMLMapMarker({
							latlng: latLng,
							map: map,
							html: `<div class="custom-marker-container"><div class="custom-pin"><span></span></div><div class="custom-line"></div><div class="custom-marker"><span>${label}</span></div></div>`
						});

					}

					map.markers.push(marker);

					if (url) {
						google.maps.event.addListener(
							marker,
							'click',
							function () {
								window.open(url, '_blank');
							}
						);
					}
				}

				function centerMap(map, zoom, markers) {

					// eslint-disable-next-line no-undef
					const bounds = new google.maps.LatLngBounds();
					// loop through all markers and create bounds

					markers.forEach((el) => {
						// eslint-disable-next-line no-undef
						const latlng = new google.maps.LatLng(
							parseFloat(el.dataset.lat),
							parseFloat(el.dataset.long),
						);
						bounds.extend(latlng);
					});

					// only 1 marker?
					if (markers.length === 1) {
						// set center of map
						map.setCenter(bounds.getCenter());
						map.setZoom(zoom);
					} else {
						// fit to bounds
						map.fitBounds(bounds);
					}
				}
			}
		}
	}

	class Handler {
		constructor(sector, sectorClass) {
			// Store values
			this.sector = sector;
			this.sectorClass = sectorClass;
			
		}
	}


	const options = {
		root: null,
		threshold: 0.5,
	};
	const mapEls = document.querySelectorAll('section.maps')
	const id = 'google-maps'
	// definition
	const loadScript = (scriptUrl) => {
		const script = document.createElement('script');
		script.setAttribute('type', 'text/javascript')
		script.setAttribute('id', id)
		script.src = scriptUrl;

		document.body.appendChild(script);
		
		return new Promise((res, rej) => {
			script.onload = function() {
				res();
			}
			script.onerror = function () {
				rej();
			}
		});
	}
  
	const handler = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				if(!document.body.querySelector('#' + id)) {
					loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCKFiF8K2RVnGytDZpzqTn4VX0APsSW2dA')
						.then(() => {
							new Maps(entry.target);
						})
						.catch(() => {
							console.error('Google map script did not load');
						});
				} 
			}
		});
	};
	
	const observer = new window.IntersectionObserver(handler, options);
	
	mapEls.forEach(element => {
		observer.observe(element)
	});
})();
